import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Input, ViewEncapsulation, NgModule } from '@angular/core';
import * as i1 from '@play/common';
import { SvgIconsModule, CommonsComponentModule, CommonsErrorModule, CommonsLoadingModule } from '@play/common';
import * as i2 from '@play/translate';
import { TranslationModule } from '@play/translate';
import * as i4 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i3 from '@play/api-client';
import * as i1$1 from '@ngrx/store';
import { getMatch, entryAvailable, StateModule } from '@play/state';
import { filter, map } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';

const _c0$2 = ["*"];
class MatchInformationSkeletonComponent {
}
MatchInformationSkeletonComponent.ɵfac = function MatchInformationSkeletonComponent_Factory(t) { return new (t || MatchInformationSkeletonComponent)(); };
MatchInformationSkeletonComponent.ɵcmp = i0.ɵɵdefineComponent({ type: MatchInformationSkeletonComponent, selectors: [["match-information-skeleton"]], ngContentSelectors: _c0$2, decls: 36, vars: 35, consts: [[1, "c-card", "c-match-information"], [1, "c-card__title", "c-match-information__title"], [1, "c-card__body", "c-match-information__body"], [1, "o-grid", "o-grid--inside"], [1, "o-grid__item", "u-1/3", "u-baseline"], [1, "o-flag"], [1, "o-flag__figure", "u-color-saturated"], [3, "icon"], [1, "o-flag__body"], [1, "c-skeleton__text"], [1, "o-grid__item", "u-2/3", "u-baseline"], [1, "c-card__footer", "c-match-information__footer"], [1, "c-flat-button--primary", "c-match-information__action", 3, "type", "disabled", "title"], [1, "c-flat-button--destructive", "c-match-information__action", 3, "type", "disabled", "title"]], template: function MatchInformationSkeletonComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "h2", 1);
        i0.ɵɵtext(2);
        i0.ɵɵpipe(3, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 2);
        i0.ɵɵelementStart(5, "div", 3);
        i0.ɵɵelementStart(6, "div", 4);
        i0.ɵɵelementStart(7, "div", 5);
        i0.ɵɵelementStart(8, "div", 6);
        i0.ɵɵelement(9, "svg-icon", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "div", 8);
        i0.ɵɵelementStart(11, "div");
        i0.ɵɵelementStart(12, "strong");
        i0.ɵɵtext(13);
        i0.ɵɵpipe(14, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(15, "div", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(16, "div", 10);
        i0.ɵɵelementStart(17, "div", 5);
        i0.ɵɵelementStart(18, "div", 6);
        i0.ɵɵelement(19, "svg-icon", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(20, "div", 8);
        i0.ɵɵelementStart(21, "div");
        i0.ɵɵelementStart(22, "strong");
        i0.ɵɵtext(23);
        i0.ɵɵpipe(24, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(25, "div", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵprojection(26);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(27, "div", 11);
        i0.ɵɵelementStart(28, "play-button", 12);
        i0.ɵɵpipe(29, "translate");
        i0.ɵɵtext(30);
        i0.ɵɵpipe(31, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(32, "play-button", 13);
        i0.ɵɵpipe(33, "translate");
        i0.ɵɵtext(34);
        i0.ɵɵpipe(35, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 21, "match-information:title"), " ");
        i0.ɵɵadvance(7);
        i0.ɵɵstyleProp("width", 32, "px")("height", 32, "px");
        i0.ɵɵproperty("icon", "info");
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(14, 23, "match-status:title"));
        i0.ɵɵadvance(6);
        i0.ɵɵstyleProp("width", 32, "px")("height", 32, "px");
        i0.ɵɵproperty("icon", "schedule");
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(24, 25, "match-schedule:title"));
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("type", "flat")("disabled", true)("title", i0.ɵɵpipeBind1(29, 27, "commons:enter-result-description"));
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(31, 29, "commons:enter-result"), " ");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("type", "flat")("disabled", true)("title", i0.ɵɵpipeBind1(33, 31, "commons:protest-match-description"));
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(35, 33, "commons:protest-match"), " ");
    } }, directives: [i1.SvgIconComponent, i1.ButtonComponent], pipes: [i2.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MatchInformationSkeletonComponent, [{
        type: Component,
        args: [{
                selector: "match-information-skeleton",
                templateUrl: "./match-information-skeleton.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], null, null); })();

const _c0$1 = function (a0) { return { "u-color-failure": a0 }; };
class MatchStatusComponent {
}
MatchStatusComponent.ɵfac = function MatchStatusComponent_Factory(t) { return new (t || MatchStatusComponent)(); };
MatchStatusComponent.ɵcmp = i0.ɵɵdefineComponent({ type: MatchStatusComponent, selectors: [["match-status"]], inputs: { state: "state" }, decls: 11, vars: 14, consts: [[1, "o-flag"], [1, "o-flag__figure", "u-color-saturated"], [3, "icon"], [1, "o-flag__body"], [3, "ngClass"]], template: function MatchStatusComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelement(2, "svg-icon", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelementStart(4, "div");
        i0.ɵɵelementStart(5, "strong");
        i0.ɵɵtext(6);
        i0.ɵɵpipe(7, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "span", 4);
        i0.ɵɵtext(9);
        i0.ɵɵpipe(10, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵstyleProp("width", 32, "px")("height", 32, "px");
        i0.ɵɵproperty("icon", "info");
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(7, 8, "match-status:title"));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(12, _c0$1, ctx.state === "protest"));
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(10, 10, "commons:match-state-" + ctx.state), " ");
    } }, directives: [i1.SvgIconComponent, i4.NgClass], pipes: [i2.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MatchStatusComponent, [{
        type: Component,
        args: [{
                selector: "match-status",
                templateUrl: "./match-status.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], null, { state: [{
            type: Input
        }] }); })();

const matchStatusTexts = {
    "match-status:title": "status",
};

class MatchScheduleComponent {
}
MatchScheduleComponent.ɵfac = function MatchScheduleComponent_Factory(t) { return new (t || MatchScheduleComponent)(); };
MatchScheduleComponent.ɵcmp = i0.ɵɵdefineComponent({ type: MatchScheduleComponent, selectors: [["match-schedule"]], inputs: { startTime: "startTime" }, decls: 9, vars: 9, consts: [[1, "o-flag"], [1, "o-flag__figure", "u-color-saturated"], [3, "icon"], [1, "o-flag__body"], [3, "date"]], template: function MatchScheduleComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelement(2, "svg-icon", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelementStart(4, "div");
        i0.ɵɵelementStart(5, "strong");
        i0.ɵɵtext(6);
        i0.ɵɵpipe(7, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(8, "format-date", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵstyleProp("width", 32, "px")("height", 32, "px");
        i0.ɵɵproperty("icon", "schedule");
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(7, 7, "match-schedule:title"));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("date", ctx.startTime);
    } }, directives: [i1.SvgIconComponent, i1.FormatDateComponent], pipes: [i2.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MatchScheduleComponent, [{
        type: Component,
        args: [{
                selector: "match-schedule",
                templateUrl: "./match-schedule.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], null, { startTime: [{
            type: Input
        }] }); })();

const matchScheduleTexts = {
    "match-schedule:title": "start time",
};

const _c0 = ["*"];
class MatchInformationComponent {
}
MatchInformationComponent.ɵfac = function MatchInformationComponent_Factory(t) { return new (t || MatchInformationComponent)(); };
MatchInformationComponent.ɵcmp = i0.ɵɵdefineComponent({ type: MatchInformationComponent, selectors: [["match-information"]], inputs: { startTime: "startTime", state: "state" }, ngContentSelectors: _c0, decls: 20, vars: 21, consts: [[1, "c-card", "c-match-information"], [1, "c-card__title", "c-match-information__title"], [1, "c-card__body", "c-match-information__body"], [1, "o-grid", "o-grid--inside"], [1, "o-grid__item", "u-1/3", "u-baseline"], [3, "state"], [1, "o-grid__item", "u-2/3", "u-baseline"], [3, "startTime"], [1, "c-card__footer", "c-match-information__footer"], [1, "c-flat-button--primary", "c-match-information__action", 3, "type", "disabled", "title"], [1, "c-flat-button--destructive", "c-match-information__action", 3, "type", "disabled", "title"]], template: function MatchInformationComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "h2", 1);
        i0.ɵɵtext(2);
        i0.ɵɵpipe(3, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 2);
        i0.ɵɵelementStart(5, "div", 3);
        i0.ɵɵelementStart(6, "div", 4);
        i0.ɵɵelement(7, "match-status", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 6);
        i0.ɵɵelement(9, "match-schedule", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵprojection(10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "div", 8);
        i0.ɵɵelementStart(12, "play-button", 9);
        i0.ɵɵpipe(13, "translate");
        i0.ɵɵtext(14);
        i0.ɵɵpipe(15, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(16, "play-button", 10);
        i0.ɵɵpipe(17, "translate");
        i0.ɵɵtext(18);
        i0.ɵɵpipe(19, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 11, "match-information:title"), " ");
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("state", ctx.state);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("startTime", ctx.startTime);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("type", "flat")("disabled", true)("title", i0.ɵɵpipeBind1(13, 13, "commons:enter-result-description"));
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(15, 15, "commons:enter-result"), " ");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("type", "flat")("disabled", true)("title", i0.ɵɵpipeBind1(17, 17, "commons:protest-match-description"));
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(19, 19, "commons:protest-match"), " ");
    } }, directives: [MatchStatusComponent, MatchScheduleComponent, i1.ButtonComponent], pipes: [i2.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MatchInformationComponent, [{
        type: Component,
        args: [{
                selector: "match-information",
                templateUrl: "./match-information.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], null, { startTime: [{
            type: Input
        }], state: [{
            type: Input
        }] }); })();

const matchInformationTexts = {
    "match-information:title": "Match Information",
};

class MatchNotFoundComponent {
}
MatchNotFoundComponent.ɵfac = function MatchNotFoundComponent_Factory(t) { return new (t || MatchNotFoundComponent)(); };
MatchNotFoundComponent.ɵcmp = i0.ɵɵdefineComponent({ type: MatchNotFoundComponent, selectors: [["match-not-found"]], decls: 4, vars: 3, consts: [[1, "c-card", "c-match-not-found"], [1, "c-card__body", "c-match-not-found__text"]], template: function MatchNotFoundComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵtext(2);
        i0.ɵɵpipe(3, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, "match-not-found:not-found"), " ");
    } }, pipes: [i2.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MatchNotFoundComponent, [{
        type: Component,
        args: [{
                selector: "match-not-found",
                templateUrl: "./match-not-found.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], null, null); })();

const matchNotFoundTexts = {
    "match-not-found:not-found": "Match has not been found.",
};

function EseaMatchButtonComponent_ng_container_0_ng_container_2_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 5);
    i0.ɵɵlistener("click", function EseaMatchButtonComponent_ng_container_0_ng_container_2_button_3_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(3); return ctx_r7.handleClick(); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 6);
    i0.ɵɵelementStart(2, "g", 7);
    i0.ɵɵelement(3, "path", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "g", 9);
    i0.ɵɵelement(5, "path", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "defs");
    i0.ɵɵelementStart(7, "clipPath", 11);
    i0.ɵɵelement(8, "rect", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "clipPath", 13);
    i0.ɵɵelement(10, "rect", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtext(11, " Join match ");
    i0.ɵɵelementEnd();
} }
function EseaMatchButtonComponent_ng_container_0_ng_container_2_play_button_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "play-button", 15);
    i0.ɵɵelement(1, "div", 16);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵclassMap("c-button--primary c-button--big c-button--esea");
    i0.ɵɵproperty("disabled", true);
} }
function EseaMatchButtonComponent_ng_container_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "p");
    i0.ɵɵtext(2, "This match is powered by ESEA integration");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, EseaMatchButtonComponent_ng_container_0_ng_container_2_button_3_Template, 12, 0, "button", 2);
    i0.ɵɵpipe(4, "async");
    i0.ɵɵtemplate(5, EseaMatchButtonComponent_ng_container_0_ng_container_2_play_button_5_Template, 2, 3, "play-button", 3);
    i0.ɵɵpipe(6, "async");
    i0.ɵɵelementStart(7, "div");
    i0.ɵɵtext(8, " or ");
    i0.ɵɵelementStart(9, "a", 4);
    i0.ɵɵtext(10, "download & install the ESEA client");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !i0.ɵɵpipeBind1(4, 2, ctx_r2.eseaLoading$));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(6, 4, ctx_r2.eseaLoading$));
} }
function EseaMatchButtonComponent_ng_container_0_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "p");
    i0.ɵɵtext(2, "This match was powered by ESEA integration");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} }
function EseaMatchButtonComponent_ng_container_0_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "p");
    i0.ɵɵtext(2, "This match is powered by ESEA integration");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p");
    i0.ɵɵtext(4, "Match is not ready to play yet");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} }
function EseaMatchButtonComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 1);
    i0.ɵɵtemplate(2, EseaMatchButtonComponent_ng_container_0_ng_container_2_Template, 11, 6, "ng-container", 0);
    i0.ɵɵtemplate(3, EseaMatchButtonComponent_ng_container_0_ng_container_3_Template, 3, 0, "ng-container", 0);
    i0.ɵɵtemplate(4, EseaMatchButtonComponent_ng_container_0_ng_container_4_Template, 5, 0, "ng-container", 0);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const match_r1 = ctx.ngIf;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", match_r1.status === "open");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", match_r1.status === "closed");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", match_r1.status !== "closed" && match_r1.status !== "open");
} }
class EseaMatchButtonComponent {
    constructor(store, location, esea) {
        this.store = store;
        this.location = location;
        this.esea = esea;
        this.eseaLoading$ = new BehaviorSubject(false);
    }
    ngOnInit() {
        this.match$ = this.store.select(getMatch(this.matchId)).pipe(filter(entryAvailable), map(match => match.entry));
    }
    handleClick() {
        this.eseaLoading$.next(true);
        const eseaMatch = this.esea.getEseaMatchForMatch(this.matchId);
        eseaMatch.subscribe(match => {
            if (match && match.connectUrl) {
                this.location.go(match.connectUrl, true);
            }
            this.eseaLoading$.next(false);
        });
    }
}
EseaMatchButtonComponent.ɵfac = function EseaMatchButtonComponent_Factory(t) { return new (t || EseaMatchButtonComponent)(i0.ɵɵdirectiveInject(i1$1.Store), i0.ɵɵdirectiveInject(i1.Location), i0.ɵɵdirectiveInject(i3.EseaResource)); };
EseaMatchButtonComponent.ɵcmp = i0.ɵɵdefineComponent({ type: EseaMatchButtonComponent, selectors: [["esea-match-button"]], inputs: { matchId: "matchId" }, decls: 2, vars: 3, consts: [[4, "ngIf"], [1, "esea-match-button"], ["class", "c-button c-button--primary c-button--big c-button--esea", 3, "click", 4, "ngIf"], [3, "disabled", "class", 4, "ngIf"], ["href", "#"], [1, "c-button", "c-button--primary", "c-button--big", "c-button--esea", 3, "click"], ["width", "172", "height", "40", "viewBox", "0 0 172 40", "fill", "none", "xmlns", "http://www.w3.org/2000/svg"], ["clip-path", "url(#clip0)"], ["d", "M29.4678 0.414795L18.8519 14.4519L0.227783 14.7362L12.3617 24.035L2.39669 38.3479L20.0624 29.842L31.9448 38.8364V24.035L50.1622 15.039L14.2606 23.4064C15.8864 21.6767 16.9886 20.321 17.5678 19.3392C18.1465 18.3579 18.5745 17.1188 18.8514 15.623L30.4867 15.3101L29.4678 0.414795V0.414795Z", "fill", "#0E9648"], ["clip-path", "url(#clip1)"], ["d", "M80.124 9.90796L79.2911 14.628H60.189L59.6892 17.4322H77.6807L76.9866 21.4303H58.9673L58.412 24.6232H77.7918L76.9588 29.3432H51.1377L54.5805 9.90796H80.124ZM80.5261 24.7343L80.8037 23.0962H87.023L86.8842 23.9004C86.7454 24.7898 87.023 25.123 87.9393 25.123H101.322C102.238 25.123 102.516 24.8166 102.71 23.9014L102.821 23.1795C102.96 22.2632 102.766 21.9578 101.905 21.9301L85.9957 21.2637C82.9694 21.1249 81.6922 19.5691 82.192 16.6548L82.664 14.0727C83.1905 11.0463 84.552 9.90796 87.5783 9.90796H106.625C109.596 9.90796 110.845 11.435 110.373 14.5169L110.179 15.8764H103.959L104.043 15.3211C104.154 14.4058 103.876 14.1004 102.96 14.1004H90.2437C89.3553 14.1004 89.0221 14.4058 88.8833 15.3221L88.8277 15.683C88.6889 16.5992 88.8555 16.8769 89.7162 16.9046L105.625 17.5988C108.679 17.7098 109.957 19.2359 109.429 22.2077L108.902 25.1785C108.374 28.2039 107.014 29.3432 104.015 29.3432H84.3021C81.3035 29.3432 79.9986 27.7606 80.5261 24.7343V24.7343ZM140.539 9.90796L139.706 14.628H120.604L120.104 17.4322H138.096L137.401 21.4303H119.381L118.826 24.6232H138.206L137.373 29.3432H111.552L114.994 9.90796H140.538H140.539ZM171.232 29.3432H164.097L162.68 26.0115H149.021L146.411 29.3432H138.775L154.823 9.90796H162.07L171.232 29.3432ZM157.85 14.739L152.491 21.5691H160.765L157.85 14.739V14.739Z", "fill", "#FAFBFA"], ["id", "clip0"], ["width", "50.39", "height", "39.2512", "fill", "white"], ["id", "clip1"], ["width", "121.59", "height", "20.1054", "fill", "white", "transform", "translate(50.39 9.57288)"], [3, "disabled"], [1, "c-skeleton__text", "c-skeleton__text--esea-button"]], template: function EseaMatchButtonComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, EseaMatchButtonComponent_ng_container_0_Template, 5, 3, "ng-container", 0);
        i0.ɵɵpipe(1, "async");
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.match$));
    } }, directives: [i4.NgIf, i1.ButtonComponent], pipes: [i4.AsyncPipe], styles: [".c-button--esea{--esea-black:17,18,17;background-color:rgba(var(--esea-black),1);border-color:rgba(var(--esea-black),1);color:var(--frozen-white);display:flex;align-items:center;margin-bottom:8px;min-width:215px}.c-button--esea:active,.c-button--esea:hover{background-color:rgba(var(--esea-black),.8);border-color:rgba(var(--esea-black),.8)}.c-button--esea svg{height:20px;width:auto;margin-right:16px}.esea-match-button{display:flex;flex-flow:column wrap;align-items:center}.c-skeleton__text--esea-button{background-image:linear-gradient(90deg,var(--midnight-grey4) 8%,var(--midnight-grey3) 18%,var(--midnight-grey4) 33%)}"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EseaMatchButtonComponent, [{
        type: Component,
        args: [{
                selector: "esea-match-button",
                templateUrl: "./esea-match-button.component.html",
                styleUrls: ["./esea-match-button.component.scss"],
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i1$1.Store }, { type: i1.Location }, { type: i3.EseaResource }]; }, { matchId: [{
            type: Input
        }] }); })();

/* tslint:disable */
const information = `
    <svg class="u-svg-text" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M11 17h2v-6h-2v6zm1-15C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zM11 9h2V7h-2v2z"/>
    </svg>
`;

/* tslint:disable */
const schedule = `
    <svg class="u-svg-text" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/>
        <path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>
    </svg>
`;

/* tslint:disable */
const circle = `
    <svg class="u-svg-text" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="10"/>
    </svg>
`;

/* tslint:disable */
const pubgWeatherSunny = `
    <svg class="u-svg-text" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path d="M12.74,5.47C15.1,6.5 16.35,9.03 15.92,11.46C17.19,12.56 18,14.19 18,16V16.17C18.31,16.06 18.65,16 19,16A3,3 0 0,1 22,19A3,3 0 0,1 19,22H6A4,4 0 0,1 2,18A4,4 0 0,1 6,14H6.27C5,12.45 4.6,10.24 5.5,8.26C6.72,5.5 9.97,4.24 12.74,5.47M11.93,7.3C10.16,6.5 8.09,7.31 7.31,9.07C6.85,10.09 6.93,11.22 7.41,12.13C8.5,10.83 10.16,10 12,10C12.7,10 13.38,10.12 14,10.34C13.94,9.06 13.18,7.86 11.93,7.3M13.55,3.64C13,3.4 12.45,3.23 11.88,3.12L14.37,1.82L15.27,4.71C14.76,4.29 14.19,3.93 13.55,3.64M6.09,4.44C5.6,4.79 5.17,5.19 4.8,5.63L4.91,2.82L7.87,3.5C7.25,3.71 6.65,4.03 6.09,4.44M18,9.71C17.91,9.12 17.78,8.55 17.59,8L19.97,9.5L17.92,11.73C18.03,11.08 18.05,10.4 18,9.71M3.04,11.3C3.11,11.9 3.24,12.47 3.43,13L1.06,11.5L3.1,9.28C3,9.93 2.97,10.61 3.04,11.3M19,18H16V16A4,4 0 0,0 12,12A4,4 0 0,0 8,16H6A2,2 0 0,0 4,18A2,2 0 0,0 6,20H19A1,1 0 0,0 20,19A1,1 0 0,0 19,18Z" />
    </svg>
`;

/* tslint:disable */
const pubgWeatherSunnyClear = `
    <svg class="u-svg-text" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path d="M12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9M12,2L14.39,5.42C13.65,5.15 12.84,5 12,5C11.16,5 10.35,5.15 9.61,5.42L12,2M3.34,7L7.5,6.65C6.9,7.16 6.36,7.78 5.94,8.5C5.5,9.24 5.25,10 5.11,10.79L3.34,7M3.36,17L5.12,13.23C5.26,14 5.53,14.78 5.95,15.5C6.37,16.24 6.91,16.86 7.5,17.37L3.36,17M20.65,7L18.88,10.79C18.74,10 18.47,9.23 18.05,8.5C17.63,7.78 17.1,7.15 16.5,6.64L20.65,7M20.64,17L16.5,17.36C17.09,16.85 17.62,16.22 18.04,15.5C18.46,14.77 18.73,14 18.87,13.21L20.64,17M12,22L9.59,18.56C10.33,18.83 11.14,19 12,19C12.82,19 13.63,18.83 14.37,18.56L12,22Z" />
    </svg>
`;

/* tslint:disable */
const pubgWeatherSunset = `
    <svg class="u-svg-text" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path d="M3,12H7A5,5 0 0,1 12,7A5,5 0 0,1 17,12H21A1,1 0 0,1 22,13A1,1 0 0,1 21,14H3A1,1 0 0,1 2,13A1,1 0 0,1 3,12M5,16H19A1,1 0 0,1 20,17A1,1 0 0,1 19,18H5A1,1 0 0,1 4,17A1,1 0 0,1 5,16M17,20A1,1 0 0,1 18,21A1,1 0 0,1 17,22H7A1,1 0 0,1 6,21A1,1 0 0,1 7,20H17M15,12A3,3 0 0,0 12,9A3,3 0 0,0 9,12H15M12,2L14.39,5.42C13.65,5.15 12.84,5 12,5C11.16,5 10.35,5.15 9.61,5.42L12,2M3.34,7L7.5,6.65C6.9,7.16 6.36,7.78 5.94,8.5C5.5,9.24 5.25,10 5.11,10.79L3.34,7M20.65,7L18.88,10.79C18.74,10 18.47,9.23 18.05,8.5C17.63,7.78 17.1,7.15 16.5,6.64L20.65,7Z" />
    </svg>
`;

/* tslint:disable */
const pubgWeatherFoggy = `
    <svg class="u-svg-text" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path d="M3,15H13A1,1 0 0,1 14,16A1,1 0 0,1 13,17H3A1,1 0 0,1 2,16A1,1 0 0,1 3,15M16,15H21A1,1 0 0,1 22,16A1,1 0 0,1 21,17H16A1,1 0 0,1 15,16A1,1 0 0,1 16,15M1,12A5,5 0 0,1 6,7C7,4.65 9.3,3 12,3C15.43,3 18.24,5.66 18.5,9.03L19,9C21.19,9 22.97,10.76 23,13H21A2,2 0 0,0 19,11H17V10A5,5 0 0,0 12,5C9.5,5 7.45,6.82 7.06,9.19C6.73,9.07 6.37,9 6,9A3,3 0 0,0 3,12C3,12.35 3.06,12.69 3.17,13H1.1L1,12M3,19H5A1,1 0 0,1 6,20A1,1 0 0,1 5,21H3A1,1 0 0,1 2,20A1,1 0 0,1 3,19M8,19H21A1,1 0 0,1 22,20A1,1 0 0,1 21,21H8A1,1 0 0,1 7,20A1,1 0 0,1 8,19Z" />
    </svg>
`;

/* tslint:disable */
const pubgWeatherRainy = `
    <svg class="u-svg-text" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path d="M9,12C9.53,12.14 9.85,12.69 9.71,13.22L8.41,18.05C8.27,18.59 7.72,18.9 7.19,18.76C6.65,18.62 6.34,18.07 6.5,17.54L7.78,12.71C7.92,12.17 8.47,11.86 9,12M13,12C13.53,12.14 13.85,12.69 13.71,13.22L11.64,20.95C11.5,21.5 10.95,21.8 10.41,21.66C9.88,21.5 9.56,20.97 9.7,20.43L11.78,12.71C11.92,12.17 12.47,11.86 13,12M17,12C17.53,12.14 17.85,12.69 17.71,13.22L16.41,18.05C16.27,18.59 15.72,18.9 15.19,18.76C14.65,18.62 14.34,18.07 14.5,17.54L15.78,12.71C15.92,12.17 16.47,11.86 17,12M17,10V9A5,5 0 0,0 12,4C9.5,4 7.45,5.82 7.06,8.19C6.73,8.07 6.37,8 6,8A3,3 0 0,0 3,11C3,12.11 3.6,13.08 4.5,13.6V13.59C5,13.87 5.14,14.5 4.87,14.96C4.59,15.43 4,15.6 3.5,15.32V15.33C2,14.47 1,12.85 1,11A5,5 0 0,1 6,6C7,3.65 9.3,2 12,2C15.43,2 18.24,4.66 18.5,8.03L19,8A4,4 0 0,1 23,12C23,13.5 22.2,14.77 21,15.46V15.46C20.5,15.73 19.91,15.57 19.63,15.09C19.36,14.61 19.5,14 20,13.72V13.73C20.6,13.39 21,12.74 21,12A2,2 0 0,0 19,10H17Z" />
    </svg>
`;

/* tslint:disable */
const pubgModeFPP = `
    <svg class="u-svg-text" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
    </svg>
`;

/* tslint:disable */
const pubgModeTPP = `
    <svg class="u-svg-text" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/>
    </svg>
`;

class MatchModule {
    constructor(iconRepository) {
        this.iconRepository = iconRepository;
        const icons = [
            { identifier: "info", icon: information },
            { identifier: "schedule", icon: schedule },
            { identifier: "circle", icon: circle },
            // Pubg Mode
            { identifier: "FPP", icon: pubgModeFPP },
            { identifier: "TPP", icon: pubgModeTPP },
            // Pubg Weather
            { identifier: "sunny", icon: pubgWeatherSunny },
            { identifier: "sunny-clear", icon: pubgWeatherSunnyClear },
            { identifier: "sunset", icon: pubgWeatherSunset },
            { identifier: "foggy", icon: pubgWeatherFoggy },
            { identifier: "rainy", icon: pubgWeatherRainy },
        ];
        icons.forEach(icon => this.iconRepository.addIcon(icon));
    }
}
MatchModule.ɵfac = function MatchModule_Factory(t) { return new (t || MatchModule)(i0.ɵɵinject(i1.SvgIconsRepository)); };
MatchModule.ɵmod = i0.ɵɵdefineNgModule({ type: MatchModule });
MatchModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            SvgIconsModule,
            CommonsComponentModule,
            CommonsErrorModule,
            CommonsLoadingModule,
            TranslationModule,
            StateModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(MatchModule, { declarations: [MatchNotFoundComponent,
        MatchInformationComponent,
        MatchScheduleComponent,
        MatchStatusComponent,
        MatchInformationSkeletonComponent,
        EseaMatchButtonComponent], imports: [CommonModule,
        SvgIconsModule,
        CommonsComponentModule,
        CommonsErrorModule,
        CommonsLoadingModule,
        TranslationModule,
        StateModule], exports: [MatchNotFoundComponent,
        MatchInformationComponent,
        MatchScheduleComponent,
        MatchStatusComponent,
        MatchInformationSkeletonComponent,
        EseaMatchButtonComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MatchModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    SvgIconsModule,
                    CommonsComponentModule,
                    CommonsErrorModule,
                    CommonsLoadingModule,
                    TranslationModule,
                    StateModule,
                ],
                declarations: [
                    MatchNotFoundComponent,
                    MatchInformationComponent,
                    MatchScheduleComponent,
                    MatchStatusComponent,
                    MatchInformationSkeletonComponent,
                    EseaMatchButtonComponent,
                ],
                exports: [
                    MatchNotFoundComponent,
                    MatchInformationComponent,
                    MatchScheduleComponent,
                    MatchStatusComponent,
                    MatchInformationSkeletonComponent,
                    EseaMatchButtonComponent,
                ],
            }]
    }], function () { return [{ type: i1.SvgIconsRepository }]; }, null); })();

/*
 * Public API Surface of match
 */

/**
 * Generated bundle index. Do not edit.
 */

export { EseaMatchButtonComponent, MatchInformationComponent, MatchInformationSkeletonComponent, MatchModule, MatchNotFoundComponent, MatchScheduleComponent, MatchStatusComponent, matchInformationTexts, matchNotFoundTexts, matchScheduleTexts, matchStatusTexts };
//# sourceMappingURL=play-match.js.map
